import React from 'react'
import { IconToggle } from 'react-mdl'

export const isAlignment = (state, alignment) => {
  const mark = state.marks.find(mark => mark.type === 'alignment')
  return mark && mark.data.get('align') === alignment
}

const markStrategy = (state, align) => {
  const transform = state
    .transform()
    .collapseToStartOf(state.anchorBlock)
    .extendToEndOf(state.anchorBlock)

  const markToRemove = transform.state.marks.find(
    ({ type }) => type === 'alignment',
  )
  markToRemove && transform.removeMark(markToRemove)
  transform.addMark({
    type: 'alignment',
    data: { align },
  })
  return transform.focus().apply()
}

const AlignLeftButton = ({ state, onChange }) => (
  <IconToggle
    name="format_align_left"
    onChange={() => onChange(markStrategy(state, 'left'))}
    checked={isAlignment(state, 'left') || false}
  />
)
const AlignCenterButton = ({ state, onChange }) => (
  <IconToggle
    name="format_align_center"
    onChange={() => onChange(markStrategy(state, 'center'))}
    checked={isAlignment(state, 'center') || false}
  />
)
const AlignRightButton = ({ state, onChange }) => (
  <IconToggle
    name="format_align_right"
    onChange={() => onChange(markStrategy(state, 'right'))}
    checked={isAlignment(state, 'right') || false}
  />
)
const AlignJustifyButton = ({ state, onChange }) => (
  <IconToggle
    name="format_align_justify"
    onChange={() => onChange(markStrategy(state, 'justify'))}
    checked={isAlignment(state, 'justify') || false}
  />
)

const Node = ({ children, mark: { data } }) => (
  <div style={{ textAlign: data.get('align') }}>
    {children}
  </div>
)

const Plugin = () => ({
  schema: {
    marks: {
      alignment: Node,
    },
  },
})

export {
  AlignLeftButton,
  AlignCenterButton,
  AlignRightButton,
  AlignJustifyButton,
  Plugin as AlignmentPlugin,
}



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Alignment.js